import { useEffect, useState } from 'react'
import getBundleDeals from '../utils/get-bundle-deals'
import getPriceCache from '../utils/get-price-cache'
import useSeti from './useSeti'

const useFetchPackages = ({
  latitude,
  longitude
}: {
  latitude: number | null
  longitude: number | null
}) => {
  const [deals, setDeals] = useState<any>([])
  const [didFetchSucceed, setFetchSucceeded] = useState(true)
  const shouldUseGraphQl =
    useSeti('PKG_LANDING_DEALS_FETCH_METHOD', true) === 'VARIANT'

  useEffect(() => {
    const fetchPackageDeals = async () => {
      if (!latitude || !longitude) {
        return []
      }
      const bundleDeals = shouldUseGraphQl
        ? await getBundleDeals({ latitude, longitude })
        : await getPriceCache({ latitude, longitude })

      if (bundleDeals.length > 0) {
        setFetchSucceeded(true)
        setDeals(bundleDeals)
      } else {
        setFetchSucceeded(false)
      }
    }
    fetchPackageDeals()
  }, [latitude, longitude, shouldUseGraphQl])

  return { deals, didFetchSucceed }
}

export default useFetchPackages
